import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';
let blogsSwiperWr = document.querySelectorAll('.blogs-swiper-wr');
blogsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    swiperOnResize('(min-width: 601px)', swiperEl,
      {
        modules: [Autoplay, Navigation],
        observer: true, //needs to calculate swiper size
        observeParents: true, //needs to calculate swiper size
        spaceBetween: 16,
        slidesPerView: 'auto',
        threshold: 10,
        slideToClickedSlide: true,
        breakpoints: {
          1024: {
            spaceBetween: 20,
          },
        },
      },
    );
  }
});

